import useSWR from "swr";
import fetcher from "./fetcher";

const endpoint = "/api/talentDashboard/getPaidV2/shops";

export default function useGetPaidShops() {
  const { data, error } = useSWR(endpoint, fetcher);

  return {
    shops: data ?? null,
    isLoading: !data && !error,
    error,
  };
}
